var WORKSPACE_ASYNC_MULTI_SELECT = 'WORKSPACE_ASYNC_MULTI_SELECT';
var FILTER_TYPES = {
  WORKSPACE_ASYNC_MULTI_SELECT: WORKSPACE_ASYNC_MULTI_SELECT
};
export default FILTER_TYPES;